import type { ReactNode, SyntheticEvent } from 'react';
import { Lock } from 'lucide-react';

import type { TotadminPermission } from 'data/__generated__';
import { useMissingPermissionsReason } from 'hooks/useHasPermission';

const blockEvent = (event: SyntheticEvent) => {
    event.preventDefault();
    event.stopPropagation();
};

/**
 * Enveloppe d'un contrôle verrouillé faute de droit : porte l'infobulle (un bouton `disabled` ne reçoit
 * pas le survol) et bloque le clic à la capture — sinon un `<Link>` parent naviguerait quand même.
 * Monté seulement quand un droit manque : c'est lui, pas le bouton, qui charge le libellé du catalogue.
 */
export function PermissionLockWrapper({
    missing,
    children,
}: {
    missing: readonly TotadminPermission[];
    children: ReactNode;
}) {
    const reason = useMissingPermissionsReason(missing);

    return (
        <span
            className="inline-flex cursor-not-allowed"
            title={reason ?? undefined}
            onClickCapture={blockEvent}
            data-test="permission-locked"
        >
            {children}
        </span>
    );
}

export const PermissionLockIcon = ({ className = 'size-3.5' }: { className?: string }) => (
    <Lock className={className} aria-hidden />
);
